(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9603],{

/***/ 33230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CartButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var _cartButton_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88759);
/* harmony import */ var _cartButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_cartButton_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var remixicon_react_ShoppingCart2FillIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62340);
/* harmony import */ var remixicon_react_ShoppingCart2FillIcon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_ShoppingCart2FillIcon__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65564);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18438);
/* harmony import */ var hooks_useRedux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62475);
/* harmony import */ var redux_slices_carts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94313);







const DrawerContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(3909), __webpack_require__.e(8577), __webpack_require__.e(3089)]).then(__webpack_require__.bind(__webpack_require__, 97179)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(97179)
            ]
    }
});
const CartContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 7936).then(__webpack_require__.bind(__webpack_require__, 27936)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(27936)
            ]
    }
});
function CartButton(param) {
    let {} = param;
    const dispatch = (0,hooks_useRedux__WEBPACK_IMPORTED_MODULE_3__/* .useAppDispatch */ .T)();
    const isDesktop = (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("(min-width: 1024px)");
    const { isCartOpen , list  } = (0,hooks_useRedux__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .C)((state)=>state.carts);
    const handleClickCartButton = ()=>{
        dispatch((0,redux_slices_carts__WEBPACK_IMPORTED_MODULE_4__/* .toggleCartButton */ .Hg)());
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_cartButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                type: "button",
                className: (_cartButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default().cartBtn),
                onClick: handleClickCartButton,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_ShoppingCart2FillIcon__WEBPACK_IMPORTED_MODULE_1___default()), {
                        size: 22
                    }),
                    !!list.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_cartButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default().indicator),
                        children: list.length
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DrawerContainer, {
                open: isCartOpen,
                onClose: handleClickCartButton,
                PaperProps: {
                    style: {
                        minWidth: isDesktop ? "500px" : "100%"
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CartContainer, {})
            })
        ]
    });
}


/***/ }),

/***/ 71528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59108);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8303);
/* harmony import */ var _loading_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38043);
/* harmony import */ var _loading_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_loading_module_scss__WEBPACK_IMPORTED_MODULE_2__);




function Loading(param) {
    let {} = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_loading_module_scss__WEBPACK_IMPORTED_MODULE_2___default().loading),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
    });
}


/***/ }),

/***/ 68900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NotificationStats; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59108);
/* harmony import */ var _notificationStats_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75548);
/* harmony import */ var _notificationStats_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_notificationStats_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var hooks_useModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1543);
/* harmony import */ var remixicon_react_Notification2LineIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79278);
/* harmony import */ var remixicon_react_Notification2LineIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Notification2LineIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65084);
/* harmony import */ var services_notification__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13643);
/* harmony import */ var contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92879);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18438);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65564);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var components_loader_loading__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71528);











const DrawerContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(()=>Promise.all(/* import() */[__webpack_require__.e(3909), __webpack_require__.e(8577), __webpack_require__.e(3089)]).then(__webpack_require__.bind(__webpack_require__, 97179)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(97179)
            ]
    }
});
const MobileDrawer = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(()=>Promise.all(/* import() */[__webpack_require__.e(3909), __webpack_require__.e(8577), __webpack_require__.e(8329), __webpack_require__.e(1040)]).then(__webpack_require__.bind(__webpack_require__, 79002)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(79002)
            ]
    }
});
const NotificationCenter = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(()=>Promise.all(/* import() */[__webpack_require__.e(7238), __webpack_require__.e(410)]).then(__webpack_require__.bind(__webpack_require__, 30410)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(30410)
            ]
    },
    loading: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_loader_loading__WEBPACK_IMPORTED_MODULE_8__["default"], {})
});
function NotificationStats(param) {
    let {} = param;
    const isMobile = (0,_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)("(max-width:640px)");
    const { isAuthenticated  } = (0,contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_6__/* .useAuth */ .a)();
    const [modal, handleOpen, handleClose] = (0,hooks_useModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const { data  } = (0,react_query__WEBPACK_IMPORTED_MODULE_4__.useQuery)([
        "notificationStatistic",
        isAuthenticated
    ], ()=>services_notification__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getStatistics */ .Z.getStatistics(), {
        enabled: isAuthenticated,
        retry: false,
        refetchInterval: 10000,
        refetchOnWindowFocus: isAuthenticated,
        staleTime: 0
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: (_notificationStats_module_scss__WEBPACK_IMPORTED_MODULE_10___default().wrapper),
                onClick: handleOpen,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_notificationStats_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Notification2LineIcon__WEBPACK_IMPORTED_MODULE_3___default()), {})
                    }),
                    !!(data === null || data === void 0 ? void 0 : data.notification) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_notificationStats_module_scss__WEBPACK_IMPORTED_MODULE_10___default().badge)
                    })
                ]
            }),
            !isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DrawerContainer, {
                open: modal,
                onClose: handleClose,
                anchor: "right",
                PaperProps: {
                    style: {
                        minWidth: "550px",
                        padding: 0
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NotificationCenter, {
                    onClose: handleClose
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileDrawer, {
                open: modal,
                onClose: handleClose,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NotificationCenter, {
                    onClose: handleClose
                })
            })
        ]
    });
}


/***/ }),

/***/ 19129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AddressContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59108);
/* harmony import */ var hooks_useModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1543);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82807);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65564);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85286);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(18438);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65084);
/* harmony import */ var contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92879);
/* harmony import */ var services_address__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79718);
/* harmony import */ var remixicon_react_MapPin2FillIcon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31185);
/* harmony import */ var remixicon_react_MapPin2FillIcon__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_MapPin2FillIcon__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _addressContainer_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4563);
/* harmony import */ var _addressContainer_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_addressContainer_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var components_loader_loading__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71528);













const AddressModal = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(()=>Promise.all(/* import() */[__webpack_require__.e(3909), __webpack_require__.e(7966), __webpack_require__.e(5828), __webpack_require__.e(2303), __webpack_require__.e(602), __webpack_require__.e(3532), __webpack_require__.e(576), __webpack_require__.e(8632)]).then(__webpack_require__.bind(__webpack_require__, 576)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(576)
            ]
    }
});
const ModalContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(()=>Promise.all(/* import() */[__webpack_require__.e(3909), __webpack_require__.e(8259)]).then(__webpack_require__.bind(__webpack_require__, 27167)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(27167)
            ]
    }
});
const MobileDrawer = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(()=>Promise.all(/* import() */[__webpack_require__.e(3909), __webpack_require__.e(8577), __webpack_require__.e(8329), __webpack_require__.e(1040)]).then(__webpack_require__.bind(__webpack_require__, 79002)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(79002)
            ]
    }
});
const SavedAddressList = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(()=>Promise.all(/* import() */[__webpack_require__.e(3909), __webpack_require__.e(7966), __webpack_require__.e(6343), __webpack_require__.e(602), __webpack_require__.e(4766)]).then(__webpack_require__.bind(__webpack_require__, 70526)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(70526)
            ]
    },
    loading: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_loader_loading__WEBPACK_IMPORTED_MODULE_10__["default"], {})
});
function AddressContainer(param) {
    let {} = param;
    var ref, ref1;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    const isDesktop = (0,_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)("(min-width:1140px)");
    const { address , location , updateAddress , updateLocation  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_5__/* .useSettings */ .r)();
    const { isAuthenticated , user  } = (0,contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_7__/* .useAuth */ .a)();
    const [savedAddressesListModal, handleOpenSavedAddressesListModal, handleCloseSavedAddressesListModal] = (0,hooks_useModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const [addressModal, handleOpenAddressModal, handleCloseAddressModal] = (0,hooks_useModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const [savedAddressList, handleOpenSavedAddressList, handleCloseSavedAddressList] = (0,hooks_useModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const [editedAddress, setEditedAddress] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const { data: addresses  } = (0,react_query__WEBPACK_IMPORTED_MODULE_6__.useQuery)([
        "addresses",
        isAuthenticated,
        user === null || user === void 0 ? void 0 : user.id
    ], ()=>services_address__WEBPACK_IMPORTED_MODULE_8__/* ["default"].getAll */ .Z.getAll({
            perPage: 100
        }), {
        onSuccess: (res)=>{
            if (res.length !== 0) {
                var ref;
                const defaultAddress = res.find((item)=>Boolean(item.active));
                if (!defaultAddress) return;
                let latlng;
                if (defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.location) {
                    latlng = "".concat(defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.location.at(0), ",").concat(defaultAddress.location.at(1));
                } else {
                    latlng = location;
                }
                updateAddress(((ref = defaultAddress.address) === null || ref === void 0 ? void 0 : ref.address) || "");
                updateLocation(latlng);
            }
        },
        enabled: isAuthenticated
    });
    const handleClickAddressRef = (event)=>{
        event.stopPropagation();
        switch(isAuthenticated){
            case false:
                handleOpenAddressModal();
                break;
            case true:
                if (addresses === null || addresses === void 0 ? void 0 : addresses.length) {
                    if (isDesktop) {
                        handleOpenSavedAddressesListModal();
                    } else {
                        handleOpenSavedAddressList(event);
                    }
                } else {
                    handleOpenAddressModal();
                }
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                type: "button",
                className: (_addressContainer_module_scss__WEBPACK_IMPORTED_MODULE_12___default().address),
                onClick: handleClickAddressRef,
                "aria-haspopup": "dialog",
                "aria-label": address ? "".concat(t("delivery.address"), ": ").concat(address) : t("delivery.address"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_addressContainer_module_scss__WEBPACK_IMPORTED_MODULE_12___default().icon),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_MapPin2FillIcon__WEBPACK_IMPORTED_MODULE_9___default()), {
                            size: 20
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_addressContainer_module_scss__WEBPACK_IMPORTED_MODULE_12___default().addressTitle),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                children: t("delivery.address")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: address
                            })
                        ]
                    })
                ]
            }),
            isDesktop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalContainer, {
                open: savedAddressesListModal,
                onClose: handleCloseSavedAddressesListModal,
                PaperProps: {
                    style: {
                        width: "730px"
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SavedAddressList, {
                    handleOpenAddressModal: handleOpenAddressModal,
                    addresses: addresses,
                    handleCloseList: handleCloseSavedAddressesListModal,
                    onSelectAddress: (value)=>{
                        setEditedAddress(value);
                        handleOpenAddressModal();
                    }
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileDrawer, {
                open: savedAddressList,
                onClose: handleCloseSavedAddressList,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SavedAddressList, {
                    handleOpenAddressModal: handleOpenAddressModal,
                    addresses: addresses,
                    handleCloseList: handleCloseSavedAddressList,
                    onSelectAddress: (value)=>{
                        setEditedAddress(value);
                        handleCloseSavedAddressList();
                        handleOpenAddressModal();
                    }
                })
            }),
            addressModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AddressModal, {
                open: addressModal,
                onClose: ()=>{
                    handleCloseAddressModal();
                    setEditedAddress(null);
                },
                latlng: (editedAddress === null || editedAddress === void 0 ? void 0 : (ref = editedAddress.location) === null || ref === void 0 ? void 0 : ref.join(",")) || location,
                address: (editedAddress === null || editedAddress === void 0 ? void 0 : (ref1 = editedAddress.address) === null || ref1 === void 0 ? void 0 : ref1.address) || address,
                fullScreen: !isDesktop,
                editedAddress: editedAddress,
                onClearAddress: ()=>setEditedAddress(null)
            })
        ]
    });
}


/***/ }),

/***/ 1543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59108);

function useModal() {
    let isOpen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isOpen);
    const handleOpen = (event)=>{
        event === null || event === void 0 ? void 0 : event.preventDefault();
        setOpen(true);
    };
    const handleClose = ()=>setOpen(false);
    return [
        open,
        handleOpen,
        handleClose
    ];
}


/***/ }),

/***/ 79718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36155);

const addressService = {
    create: (data)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("dashboard/user/addresses", data).then((res)=>res.data),
    update: (id, data)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .Z.put("dashboard/user/addresses/".concat(id), data).then((res)=>res.data),
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("dashboard/user/addresses", {
            params
        }).then((res)=>res.data),
    setDefault: (id)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("dashboard/user/address/set-active/".concat(id)).then((res)=>res.data),
    delete: (id)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .Z["delete"]("dashboard/user/addresses/delete?ids[0]=".concat(id)).then((res)=>res.data)
};
/* harmony default export */ __webpack_exports__["Z"] = (addressService);


/***/ }),

/***/ 13643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36155);

const notificationService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/dashboard/notifications", {
            params
        }),
    getById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/dashboard/notifications/".concat(id), {
            params
        }),
    getStatistics: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/dashboard/user/profile/notifications-statistic", {
            params
        }),
    readAll: (data)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/dashboard/notifications/read-all", data),
    readById: (id, data)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/dashboard/notifications/".concat(id, "/read-at"), data)
};
/* harmony default export */ __webpack_exports__["Z"] = (notificationService);


/***/ }),

/***/ 88759:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cartBtnWrapper":"cartButton_cartBtnWrapper__s1KDe","cartBtn":"cartButton_cartBtn__rc1gE","text":"cartButton_text__l8_Mk","price":"cartButton_price__gFdJ8","container":"cartButton_container__J0g_P","indicator":"cartButton_indicator__Rk4bJ"};

/***/ }),

/***/ 38043:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading_loading__hXLim","pageLoading":"loading_pageLoading__0nn5j"};

/***/ }),

/***/ 75548:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"notificationStats_wrapper__t6Wl5","icon":"notificationStats_icon__sVy39","badge":"notificationStats_badge__72wCW"};

/***/ }),

/***/ 4563:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"address":"addressContainer_address__0f1YB","icon":"addressContainer_icon__993dr","addressTitle":"addressContainer_addressTitle__nIMg6","addressWrapper":"addressContainer_addressWrapper__vy0he","list":"addressContainer_list__O2lVD","radioGroup":"addressContainer_radioGroup__6CuEt","radio":"addressContainer_radio__fhZf_","text":"addressContainer_text__hrb7I","twoLine":"addressContainer_twoLine__ANzOV","desc":"addressContainer_desc__nvBaM","edit":"addressContainer_edit__9DwcA","add":"addressContainer_add__ZJxjJ","savedAddressListContainer":"addressContainer_savedAddressListContainer__z2PKD","containerTitle":"addressContainer_containerTitle__RgPlg","addAddress":"addressContainer_addAddress__dSggz","swiper":"addressContainer_swiper__a82Xo","swiperSlide":"addressContainer_swiperSlide__tK6Eg","map":"addressContainer_map__eTsZC","cardContainer":"addressContainer_cardContainer__rIKVA","body":"addressContainer_body__xIwpn","title":"addressContainer_title__Zp31Q","description":"addressContainer_description__KJErH","moreOptions":"addressContainer_moreOptions__7Ev1f","cardContainerActive":"addressContainer_cardContainerActive__VvDyW","popoverContainer":"addressContainer_popoverContainer__gTw_I","item":"addressContainer_item__69sLv"};

/***/ }),

/***/ 31185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(59108);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var MapPin2FillIcon = function MapPin2FillIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M18.364 17.364L12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0zM12 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4z' })
  );
};

var MapPin2FillIcon$1 = React__default['default'].memo ? React__default['default'].memo(MapPin2FillIcon) : MapPin2FillIcon;

module.exports = MapPin2FillIcon$1;


/***/ }),

/***/ 79278:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(59108);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var Notification2LineIcon = function Notification2LineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M22 20H2v-2h1v-6.969C3 6.043 7.03 2 12 2s9 4.043 9 9.031V18h1v2zM5 18h14v-6.969C19 7.148 15.866 4 12 4s-7 3.148-7 7.031V18zm4.5 3h5a2.5 2.5 0 1 1-5 0z' })
  );
};

var Notification2LineIcon$1 = React__default['default'].memo ? React__default['default'].memo(Notification2LineIcon) : Notification2LineIcon;

module.exports = Notification2LineIcon$1;


/***/ }),

/***/ 62340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(59108);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ShoppingCart2FillIcon = function ShoppingCart2FillIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M4 6.414L.757 3.172l1.415-1.415L5.414 5h15.242a1 1 0 0 1 .958 1.287l-2.4 8a1 1 0 0 1-.958.713H6v2h11v2H5a1 1 0 0 1-1-1V6.414zM5.5 23a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm12 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z' })
  );
};

var ShoppingCart2FillIcon$1 = React__default['default'].memo ? React__default['default'].memo(ShoppingCart2FillIcon) : ShoppingCart2FillIcon;

module.exports = ShoppingCart2FillIcon$1;


/***/ })

}]);